import { Checkbox } from "@/components/ui/checkbox"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { ComponentPropsWithRef } from "react"

export type CheckboxFieldProps = Omit<
  ComponentPropsWithRef<typeof CheckboxPrimitive.Root>,
  "value"
> & {
  onChange: (...event: any[]) => void
  value?: boolean
}

export function CheckboxField({
  value,
  onChange,
  name,
  ref,
  ...rest
}: CheckboxFieldProps) {
  return (
    <Checkbox
      id={name}
      checked={value ?? false}
      onCheckedChange={onChange}
      ref={ref}
      {...rest}
    />
  )
}
